
import React from 'react';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';

interface NotifyEmailsFieldProps {
  notifyEmails: string;
  onNotifyEmailsChange?: (value: string) => void;
}

export function NotifyEmailsField({
  notifyEmails,
  onNotifyEmailsChange
}: NotifyEmailsFieldProps) {
  return (
    <div className="space-y-2">
      <Label htmlFor="notify-emails">Notify Emails</Label>
      <Textarea
        id="notify-emails"
        placeholder="Enter email addresses (one per line) to notify when assessment is completed"
        value={notifyEmails}
        onChange={(e) => {
          if (onNotifyEmailsChange) {
            onNotifyEmailsChange(e.target.value);
          }
        }}
        rows={3}
      />
      <p className="text-sm text-muted-foreground">
        Enter email addresses of those you want to notify when a user completes this assessment.
      </p>
    </div>
  );
}
